import styled from '@emotion/styled';
import { EnhancedSelect as _EnhancedSelect } from 'common/components/EnhancedSelect/EnhancedSelect';

export const SSelectGroup = styled.div`
  display: block;
  position: relative;
  margin-top: 12px;
  width: 75%;
`;

export const SEnhancedSelect = styled(_EnhancedSelect)`
  width: 100%;
  &:not(:first-of-type) .ant-select-selector {
    border-left: 0;
  }
`;

export const SSelectRow = styled.div<{ mt?: number }>`
  ${({ mt = 8 }): string => `margin-top: ${mt}px;`}
  display: flex;
  & ${SEnhancedSelect}:first-of-type {
    width: 25%;
    & .ant-select-selection-item {
      font-size: 13px;
    }
  }
  & ${SEnhancedSelect}:not(:first-of-type) {
    width: 75%;
  }
`;

export const SEnhancedSelect2 = styled(_EnhancedSelect)`
  margin-left: 20px;
`;
